// Model 1b: en lektion gates KUN hvis dens linkede fagdoer staar paa UDVALGTE ELEVER.
// Cache af restricted doer-ids. Retry ved fejl (rules kan kraeve auth ved load).
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';
const restricted = new Set<string>();
let started = false;
const start = () => {
    if (started) return; started = true;
    try {
        onSnapshot(collection(db, 'subjects'), (snap) => {
            restricted.clear();
            snap.forEach((d) => { if ((d.data() as any)?.visibility === 'selected_students') restricted.add(d.id); });
        }, (err) => { console.error('[doorGate] LYTTER-FEJL, retry 5s:', (err as any)?.code || err); started = false; setTimeout(start, 5000); });
    } catch (e) { console.error('[doorGate] START-FEJL:', e); started = false; setTimeout(start, 5000); }
};
start();
export const isDoorRestricted = (sid: string): boolean => restricted.has(sid);
